import request from "../utils/request";

export function fetcTableData(params) {
  // is_paginated=0 page page_size
  // let data = [
  //   {
  //     id: 1,
  //     code_region: "1703",
  //     SI: "1.2",
  //     NO: "3.8",
  //     SO2: "2.5",
  //     CO: "2.1",
  //     NO2: "9.1",
  //     PM2_5: "2.8",
  //     PM10: "7.4",
  //     NH3: "0.1",
  //     O3: "0.4",
  //     C6H60: "4.2",
  //     location: "location",
  //     date: new Date().toLocaleDateString()
  //   }
  // ];
  // return Promise.resolve({ data: { data, count: 1 } });
  return request({
    url: "/api/orgs/hydro-metrology/",
    method: "get",
    params
  });
}
export function fetchChartData(params) {
  // is_paginated=0 page page_size

  return Promise.resolve([]);
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
export function fetchLocationData(params) {
  // is_paginated=0 page page_size

  return Promise.resolve({});
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
